import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import blogPosts from '../data/blog/posts';
import appIcon from '../assets/icon.png';
import './Blog.css';

const estimateReadTime = (content) => {
  const words = content.trim().split(/\s+/).length;
  return Math.max(1, Math.round(words / 230));
};

const BlogIndex = () => {
  return (
    <div className="blog-page">
      <Helmet>
        <title>Blog | Forecast — Budget Calendar App</title>
        <meta name="description" content="Tips, guides, and strategies for budgeting, forecasting your bank balance, and taking control of your finances." />
        <link rel="canonical" href="https://tryforecast.app/blog" />
      </Helmet>

      <nav className="blog-nav">
        <div className="blog-nav-inner">
          <Link to="/" className="blog-nav-brand">
            <img src={appIcon} alt="Forecast" />
            <span>Forecast</span>
          </Link>
          <div className="blog-nav-links">
            <Link to="/support" className="blog-nav-link">Support</Link>
            <Link to="/" className="blog-nav-cta">Try Forecast</Link>
          </div>
        </div>
      </nav>

      <div className="blog-index-header">
        <span className="blog-index-label">Blog</span>
        <h1 className="blog-index-title">Money tips that<br />actually help</h1>
        <p className="blog-index-subtitle">
          Practical guides for budgeting, forecasting your balance, and getting ahead financially.
        </p>
      </div>

      <div className="blog-index-grid">
        {blogPosts.map((post) => (
          <Link key={post.slug} to={`/blog/${post.slug}`} className="blog-card">
            <div className="blog-card-meta">
              <span className="blog-card-date">
                {new Date(post.date + 'T12:00:00').toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </span>
              <span className="blog-card-dot" />
              <span className="blog-card-readtime">{estimateReadTime(post.content)} min read</span>
            </div>
            <h2 className="blog-card-title">{post.title}</h2>
            <p className="blog-card-description">{post.description}</p>
            <span className="blog-card-arrow">Read more &rarr;</span>
          </Link>
        ))}
      </div>

      <footer className="blog-footer">
        <span className="blog-footer-text">&copy; {new Date().getFullYear()} Forecast</span>
        <div className="blog-footer-links">
          <Link to="/privacy-policy" className="blog-footer-link">Privacy</Link>
          <Link to="/terms-of-service" className="blog-footer-link">Terms</Link>
          <Link to="/support" className="blog-footer-link">Support</Link>
        </div>
      </footer>
    </div>
  );
};

export default BlogIndex;
